import { records, type PersonalBestRecordItem } from '../services/api';
import type { PeakTrendPoint } from './coachPeakTrends';
import { weeklyPeakWinners } from './weeklyPeakTrends';

export function summarizePeakRow(points: PeakTrendPoint[], lowerIsBetter = false) {
  const weekly = [...weeklyPeakWinners(points, lowerIsBetter).values()].sort((a, b) => a.x - b.x);
  const first = weekly[0];
  const latest = weekly[weekly.length - 1];
  const change = weekly.length > 1 && first.y > 0 ? (latest.y - first.y) / first.y * 100 : null;
  return { weekly, latest, change };
}

/** Split saturated ranges so long dashboard selections are not silently truncated. */
export async function loadPeakHistory(userId: number, start: string, end: string, params: Record<string, string | number | boolean>): Promise<PersonalBestRecordItem[]> {
  const response = await records.getHistory(userId, { ...params, start_date: start, end_date: end, best_only: 0, limit: 500 });
  const rows = response.data?.data ?? [];
  if (rows.length < 500 || start === end) return rows;
  const day = 86400000;
  const mid = Math.floor((Date.parse(start) / day + Date.parse(end) / day) / 2) * day;
  const first = await loadPeakHistory(userId, start, new Date(mid).toISOString().slice(0, 10), params);
  const second = await loadPeakHistory(userId, new Date(mid + day).toISOString().slice(0, 10), end, params);
  return [...new Map([...first, ...second].map(row => [row.id, row])).values()];
}
